export const widgetDefaults = {
  pageName: 'booking_form_widget',
};

export const WIDGET_NAME = 'bookings_form';
